module.exports = __webpack_public_path__ + "fonts/font-icon-Enerdata.3549bc9.eot";